import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import Pagination from '@atlaskit/pagination';

var ManagedPagination = /*#__PURE__*/function (_React$Component) {
  _inherits(ManagedPagination, _React$Component);

  var _super = _createSuper(ManagedPagination);

  function ManagedPagination() {
    var _this;

    _classCallCheck(this, ManagedPagination);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onChange", function (_event, newValue, analyticsEvent) {
      _this.props.onChange(newValue, analyticsEvent);
    });

    return _this;
  }

  _createClass(ManagedPagination, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          total = _this$props.total,
          _this$props$value = _this$props.value,
          value = _this$props$value === void 0 ? 1 : _this$props$value,
          i18n = _this$props.i18n;

      var pages = _toConsumableArray(Array(total)).map(function (_, index) {
        return index + 1;
      }); // Pagination accepts array now thus selectedIndex starts with 0
      // So, we are substracting value by one thus not breaking dynamic table


      var selectedIndex = value - 1;
      return /*#__PURE__*/React.createElement(Pagination, {
        selectedIndex: selectedIndex,
        i18n: i18n,
        onChange: this.onChange,
        pages: pages
      });
    }
  }]);

  return ManagedPagination;
}(React.Component);

export { ManagedPagination as default };